
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/support",
      function () {
        return require("private-next-pages/support/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/support"])
      });
    }
  